function gatherProperties(propertyList, host) {
  const ownProperties = Object.getOwnPropertyNames(host);
  propertyList.forEach((propertyName) => {
    const hasPreInitValue = ownProperties.includes(propertyName.toString());
    if (hasPreInitValue) {
      if (host.preDefinitionProperties === void 0)
        host.preDefinitionProperties = {};
      host.preDefinitionProperties[propertyName] = host[propertyName];
      delete host[propertyName];
    }
  });
}
function initGatheredProperties(host) {
  if (host.preDefinitionProperties) {
    Object.assign(host, host.preDefinitionProperties);
    delete host.preDefinitionProperties;
  }
}
export {
  gatherProperties,
  initGatheredProperties
};
